// App display version shown in the StatusFooter (bottom-right, after the DB
// name). Bump this on each release. CRA blocks importing the root package.json
// from src/, so this is the canonical display version — keep package.json
// "version" in sync when you bump.
export const APP_VERSION = '0.1.103';
